import { useSelector } from "react-redux";

import type { RootState } from "../../../store/store";
import type { SxProps, Theme } from "@mui/material/styles";

/**
 * Incoming calls are operational interruptions and must sit above every app
 * dialog, drawer, snackbar, and tooltip.
 */
export const getIncomingCallOverlayZIndex = (theme: Theme) =>
  Math.max(theme.zIndex.modal, theme.zIndex.snackbar, theme.zIndex.tooltip) + 100;

export const incomingCallDrawerSx: SxProps<Theme> = (theme) => {
  const overlayZIndex = getIncomingCallOverlayZIndex(theme);

  return {
    zIndex: overlayZIndex,
    "& .MuiBackdrop-root": {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: overlayZIndex,
    },
    "& .MuiDrawer-paper": {
      zIndex: overlayZIndex + 1,
    },
  };
};

export const incomingCallPopperSx: SxProps<Theme> = (theme) => ({
  zIndex: getIncomingCallOverlayZIndex(theme) + 10,
});

export const incomingCallOverlaySx =
  (tier: number): SxProps<Theme> =>
  (theme) => ({
    zIndex: getIncomingCallOverlayZIndex(theme) + tier * 10,
  });

export const incomingCallNestedPopperSx = incomingCallOverlaySx(2);
export const incomingCallDeepPopperSx = incomingCallOverlaySx(3);

export const getBackgroundOverlayFocusProps = (incomingCallOpen: boolean) => ({
  disableAutoFocus: incomingCallOpen,
  disableEnforceFocus: incomingCallOpen,
  disableRestoreFocus: incomingCallOpen,
});

export const useIncomingCallOverlayActive = () =>
  useSelector((state: RootState) => state.incomingCalls.isOpen);
